module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1156039"
    }
  }, [_c('b', [_vm._v("EGGS STUFFED WITH SMOKED "), _c('br'), _vm._v(" SALMON AND CUCUMBERS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1156839"
    }
  }, [_c('b', [_c('i', [_vm._v("Make the filling up to a day before, then stuff the eggs well before your guests arrive. These light, fresh flavors are the perfect accompaniment to a spring celebration.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1158139"
    }
  }, [_c('b', [_vm._v("Prep: 30 minutes plus chilling       Cook: 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1158639"
    }
  }, [_vm._v("10 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1158939"
    }
  }, [_vm._v("2 ounces smoked salmon, finely chopped (⅓ cup)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1160039"
    }
  }, [_vm._v("3 tablespoons light mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1160339"
    }
  }, [_vm._v("¼ cup finely chopped cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1161339"
    }
  }, [_vm._v("2 teaspoons chopped fresh dill "), _c('br'), _vm._v(" plus sprigs for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1161939"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1163139"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 4-quart saucepan, place eggs and enough "), _c('i', [_vm._v("cold water ")]), _vm._v("to cover by at least 1 inch; heat to boiling on high. Immediately remove saucepan from heat and cover tightly; let stand 15 minutes. Pour off hot water, and run cold water over eggs to cool. Peel eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1165839"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Slice eggs lengthwise in half. Gently remove yolks and place in medium bowl; with fork, break yolks into chunks. Reserve 1 tablespoon chopped salmon and add remaining salmon to egg yolks. Add mayonnaise, cucumber, chopped dill, and pepper; gently stir until combined. (Egg-yolk mixture and egg whites can now be covered separately and refrigerated up to 24 hours.)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1168739"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Place egg whites on serving dish or in jelly-roll pan lined with paper towels (to prevent eggs from rolling). Spoon about 1 tablespoon egg-yolk mixture into each egg-white half. Top eggs with reserved chopped salmon. Cover eggs and refrigerate up to 4 hours. Just before serving, garnish with dill sprigs. Makes 20 appetizer servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1171839"
    }
  }, [_vm._v("Each serving: About 50 calories, 4g protein, 1g carbohydrate, 3g total fat (1g saturated), 0g fiber, 108mg cholesterol, 70mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0039_001",
      "src": "Images/9781618371621_0039_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1173039"
    }
  }, [_c('i', [_vm._v("Eggs Stuffed with Smoked Salmon and Cucumbers")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b09b37c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c27_r1.vue
// module id = 147
// module chunks = 0